function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "29.47%",
  y1: "96.183%",
  x2: "123.278%",
  y2: "37.719%",
  id: "b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  stopOpacity: "0",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("path", {
  d: "M715 1410a9 9 0 10-6.38-2.652",
  id: "a"
}), /*#__PURE__*/React.createElement("mask", {
  id: "c",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: "-3",
  y: "-3",
  width: "24",
  height: "24"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M703 1389h24v24h-24z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
}))), /*#__PURE__*/React.createElement("use", {
  mask: "url(#c)",
  transform: "rotate(-170 302.74 737.252)",
  xlinkHref: "#a",
  stroke: "url(#b)",
  strokeWidth: "6",
  fill: "none",
  fillRule: "evenodd"
})));